var styles = {
  "FilterButton": "Polaris-Filters-FilterPill__FilterButton",
  "focusedFilterButton": "Polaris-Filters-FilterPill--focusedFilterButton",
  "ActiveFilterButton": "Polaris-Filters-FilterPill__ActiveFilterButton",
  "PlainButton": "Polaris-Filters-FilterPill__PlainButton",
  "ToggleButton": "Polaris-Filters-FilterPill__ToggleButton",
  "clearButton": "Polaris-Filters-FilterPill--clearButton",
  "IconWrapper": "Polaris-Filters-FilterPill__IconWrapper",
  "PopoverWrapper": "Polaris-Filters-FilterPill__PopoverWrapper",
  "ClearButtonWrapper": "Polaris-Filters-FilterPill__ClearButtonWrapper"
};

export { styles as default };
